import { Lei } from "./Lei";

export default Lei